"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasEmailFreeOrStarter = exports.getHasEmailAccess = exports.getHasCreateEmailAccess = exports.getHasSitePagesAccess = exports.getHasCreateSitePageAccess = exports.getHasCreateLandingPageAccess = exports.getIsTrialPortal = exports.getHasCreatePageTemplateInstallPromptAccess = exports.getPortalName = exports.getHasContentAccess = exports.getHasInstallAccess = exports.getIsCustomer = exports.getCurrentUserFullName = exports.getCurrentUserId = exports.getCurrentUserEmail = exports.getHasScope = exports.getIsUngated = exports.getPortal = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _reselect = require("reselect");

var _I18n = _interopRequireDefault(require("I18n"));

var _formatName = _interopRequireDefault(require("I18n/utils/formatName"));

var _immutable = require("immutable");

var getGates = function getGates(state) {
  return state.auth.allGates;
};

var getPortal = function getPortal(state) {
  return state.auth.portal;
};

exports.getPortal = getPortal;

var getScopes = function getScopes(state) {
  return state.auth.scopes;
};

var getUser = function getUser(state) {
  return state.auth.user;
};

var getIsUngated = (0, _reselect.createSelector)([getGates], function (gates) {
  return function (gate) {
    return (0, _immutable.Set)(gates).has(gate);
  };
});
exports.getIsUngated = getIsUngated;
var getHasScope = (0, _reselect.createSelector)([getScopes], function (scopes) {
  return function (scope) {
    return !!(scopes && scopes[scope]);
  };
});
exports.getHasScope = getHasScope;
var getCurrentUserEmail = (0, _reselect.createSelector)([getUser], function (user) {
  return user.email;
});
exports.getCurrentUserEmail = getCurrentUserEmail;
var getCurrentUserId = (0, _reselect.createSelector)([getUser], function (user) {
  return user.user_id;
});
exports.getCurrentUserId = getCurrentUserId;
var getCurrentUserFullName = (0, _reselect.createSelector)([getUser], function (user) {
  return (0, _formatName.default)({
    firstName: user.first_name,
    lastName: user.last_name
  });
});
exports.getCurrentUserFullName = getCurrentUserFullName;
var getIsCustomer = (0, _reselect.createSelector)([getPortal], function (portal) {
  return !!portal.portal_id;
});
exports.getIsCustomer = getIsCustomer;
var getHasInstallAccess = (0, _reselect.createSelector)([getHasScope], function (hasScope) {
  return hasScope('marketplace-asset-access');
});
exports.getHasInstallAccess = getHasInstallAccess;
var getHasContentAccess = (0, _reselect.createSelector)([getHasScope], function (hasScope) {
  return hasScope('content-access');
});
exports.getHasContentAccess = getHasContentAccess;
var getPortalName = (0, _reselect.createSelector)([getPortal], function (portal) {
  if (!(portal.domain || portal.portal_id)) {
    return '';
  }

  return portal.domain || _I18n.default.text('MarketplaceUI.portalName.hubId', {
    portalId: portal.portal_id
  });
});
exports.getPortalName = getPortalName;
var getHasCreatePageTemplateInstallPromptAccess = (0, _reselect.createSelector)([getHasScope], function (hasScope) {
  return hasScope('create-page-template-install-prompt-access');
});
exports.getHasCreatePageTemplateInstallPromptAccess = getHasCreatePageTemplateInstallPromptAccess;
var getIsTrialPortal = (0, _reselect.createSelector)([getPortal], function (portal) {
  return (0, _typeof2.default)(portal) === 'object' && !!portal.trial;
});
exports.getIsTrialPortal = getIsTrialPortal;
var getHasCreateLandingPageAccess = (0, _reselect.createSelector)([getHasScope], function (hasScope) {
  return hasScope('landingpages-write');
});
exports.getHasCreateLandingPageAccess = getHasCreateLandingPageAccess;
var getHasCreateSitePageAccess = (0, _reselect.createSelector)([getHasScope], function (hasScope) {
  return hasScope('pages-write');
});
exports.getHasCreateSitePageAccess = getHasCreateSitePageAccess;
var getHasSitePagesAccess = (0, _reselect.createSelector)([getHasScope], function (hasScope) {
  return hasScope('sitepages-access');
});
exports.getHasSitePagesAccess = getHasSitePagesAccess;
var getHasCreateEmailAccess = (0, _reselect.createSelector)([getHasScope], function (hasScope) {
  return hasScope('email-write');
});
exports.getHasCreateEmailAccess = getHasCreateEmailAccess;
var getHasEmailAccess = (0, _reselect.createSelector)([getHasScope], function (hasScope) {
  return hasScope('email-access');
});
exports.getHasEmailAccess = getHasEmailAccess;
var getHasEmailMarketingProductAccess = (0, _reselect.createSelector)([getHasScope], function (hasScope) {
  return hasScope('email-marketing-product-access');
});
var getHasCoreContentAccess = (0, _reselect.createSelector)([getHasScope], function (hasScope) {
  return hasScope('content-core-api-access');
});
var getHasEmailEditorAccess = (0, _reselect.createSelector)([getHasScope], function (hasScope) {
  return hasScope('email-editor-access');
});
var getHasEmailSendingStarter = (0, _reselect.createSelector)([getHasScope], function (hasScope) {
  return hasScope('email-sending-starter');
});
var getHasEmailFreeOrStarter = (0, _reselect.createSelector)([getHasEmailMarketingProductAccess, getHasCoreContentAccess, getHasEmailEditorAccess, getHasEmailSendingStarter], function (hasEmailMarketingProductAccess, hasCoreContentAccess, hasEmailEditorAccess, hasEmailSendingStarter) {
  // Free email scopes
  if (hasEmailMarketingProductAccess && !hasCoreContentAccess && hasEmailEditorAccess) {
    return true;
  } // Starter email scopes


  if (hasEmailMarketingProductAccess && hasEmailSendingStarter) {
    return true;
  }

  return false;
});
exports.getHasEmailFreeOrStarter = getHasEmailFreeOrStarter;